<template>
  <div>
    <div class="nav-pagination">
      <div class="container">
        <hr class="hraing" />
        <div class="row">
          <div class="col-md-6 col-sm-6">
            <div class="sooper-text">
              <h4>{{post.name}}</h4>
            </div>
          </div>
          <div class="col-md-6 col-sm-6 text-right nav-pagination1">
            <ul>
              <li>
                <a href="index.html">Content</a>
              </li>
              <li>|</li>
              <li>Guides</li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <div class="container blog">
      <div class="column">
        <div class="col-md-9">
          <div class="row">
            <div class="col-md-12">
              <div class="blog-text wow animated slideInUp">
                <h1 class="post-para">{{post.name}}</h1>
                <h5>{{post.catagory}}</h5>
                <div class="blog-para" id="content"></div>
              </div>
              <br />
            </div>
          </div>
        </div>
      </div>
      <div class="column">
        <div class="col-md-3">
          <div class="blog-text wow animated slideInUp">
            <h4>Guide Summary</h4>
            <h5 v-for="index in indexes" :key="index.data">
              <a
                :href="$route.path+'?post_id='+$route.query.post_id+'#'+indexes.indexOf(index)"
              >{{index}}</a>
            </h5>
            <p class="blog-para"></p>
          </div>
          <br />
          <div class="blog-text main-3-section unoorder wow animated slideInUp">
            <h4>Follow Us</h4>
            <center>
              <ul>
                <li class="twitter-icon">
                  <a href="mailto:info@discovranalytics.co">
                    <i class="fa fa-envelope" aria-hidden="true"></i>
                  </a>
                </li>
                <li class="twitter-icon">
                  <a href="https://www.linkedin.com/company/discovr-analytics/" target="about_">
                    <i class="fa fa-linkedin" aria-hidden="true"></i>
                  </a>
                </li>
                <li class="twitter-icon">
                  <a href="https://www.instagram.com/discovr.analytics/" target="about_">
                    <i class="fa fa-instagram" aria-hidden="true"></i>
                  </a>
                </li>
                <li class="twitter-icon">
                  <a href="https://twitter.com/DiscovrAnalytic" target="about_">
                    <i class="fa fa-twitter" aria-hidden="true"></i>
                  </a>
                </li>
              </ul>
            </center>
          </div>
          <br />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import marked from "marked";

export default {
  name: "Guide",
  metaInfo() {
    return {
      meta: [{ name: "description", content: `${this.post.metaDes}` }],
      htmlAttrs: {
        lang: "en"
      },
      title: `${this.post.name}`,
      // override the parent template and just use the above title only
      titleTemplate: null
    };
  },
  data: function() {
    return {
      scrolled: true,
      post: [],
      indexes: [],
      route: this.$route.query
    };
  },
  components: {},
  created: function() {
    const contentful = require("contentful");
    const client = contentful.createClient({
      // This is the space ID. A space is like a project folder in Contentful terms
      space: "055zjod1n9jp",
      // This is the access token for this space. Normally you get both ID and the token in the Contentful web app
      accessToken: "TagtkY-mvVnDjYZExfWoe5ITe-7GUHdI6bwFWTXsOUA"
    });

    client
      .getEntry(this.$route.query.post_id)
      .then(entry => {
        console.log(this.$route.query);
        this.post = [];
        this.indexes = [];
        this.post.name = entry.fields.title;
        this.post.catagory = entry.fields.category;
        this.post.content = entry.fields.contents;
        this.indexes = entry.fields.index;
        this.post.metaDes = entry.fields.metaDescription;
        document.getElementById("content").innerHTML = marked(
          this.post.content
        );
      })

      .catch(error => console.log(error));
  },
  mounted() {
    window.scrollTo(0, 0);
  },
  beforeDestroy() {
    window.analytics.page("Post" & this.$route.query.post_id);
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
 @import '../css/font-awesome.min.css';
</style>
